import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import SPPAService from "services/insurance/SPPAService";
import { notification } from "antd";

export const initialState = {
    loading: false,
    message: "",
    showMessage: false,
    redirect: "",
    token: localStorage.getItem(AUTH_TOKEN) || null,
    result: {},
    refreshList: false,
    getPageSize: "",
    getPageIndex: "",
    getCount: "",
    SPPALoanList: [],
    statusRespon: 0,
    SPPALoanDetail: {},
    amortisasi:{},
    infoKredit: {},
};

export const getSPPASlice = createAsyncThunk(
    "SPPA/getSPPASlice",
    async (userInput, { rejectWithValue }) => {
        try {
            const response = await SPPAService.getSPPALoans(userInput);
            if (response.status === 200) {
                if (response && response.data) {
                    return response.data;
                }
            } else {
                console.log("Selain Response 200");
                // notification.error({
                //   message: "Error",
                //   description: "Unexpected response!",
                //   duration: 3,
                // });
                return rejectWithValue({
                    status: "Error",
                    response: response?.data?.message || "Unexpected response!",
                });
            }
        } catch (error) {
            console.log("🚀 ~ error in signIn:", error);
            notification.error({
                message: error.response.status,
                description: error.response.statusText,
                duration: 3,
            });
            return rejectWithValue(
                error.response?.data?.message || "Unexpected response!"
            );
        }
    }
);

export const getSPPALoanDetailSlice = createAsyncThunk(
    "SPPA/getSPPALoanDetailSlice",
    async (userInput, { rejectWithValue }) => {
        try {
            const response = await SPPAService.getSPPALoanDetail(userInput);
            if (response.status === 200) {
                if (response && response.data) {
                    return response.data;
                }
            } else {
                console.log("Selain Response 200");
                return rejectWithValue({
                    status: "Error",
                    response: response?.data?.message || "Unexpected response!",
                });
            }
        } catch (error) {
            console.log("error :", error);
            notification.error({
                message: error.response.status,
                description: error.response.statusText,
                duration: 3,
            });
            return rejectWithValue(
                error.response?.data?.message || "Unexpected response!"
            );
        }
    }
);

// === UPDATE STATUS ===
export const putSPPAStatus = createAsyncThunk(
    "SPPA/putSPPAStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await SPPAService.putSPPAStatus(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const cetakSPPAMulti = createAsyncThunk(
    "sppa/cetakSPPAMulti",
    async (loanIds, { rejectWithValue }) => {
        try {
            const blob = await SPPAService.cetakSPPAMulti(loanIds);
            const url = window.URL.createObjectURL(blob);
            window.open(url, "_blank"); // buka hasil PDF di tab baru
            return true;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// === UPDATE STATUS ===
export const saveTerimaPolis = createAsyncThunk(
    "SPPA/SaveTeimaPolis",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await SPPAService.saveTerimaPolis(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const SPPASlice = createSlice({
    name: "SPPA",
    initialState,
    reducers: {
        showNotification: (state, action) => {
            state.message = action.payload;
            state.showMessage = true;
            state.loading = false;
        },
        hideNotification: (state, action) => {
            state.message = "";
            state.showMessage = false;
        },
        showLoading: (state, action) => {
            state.loading = true;
        },
        resetStatusRespon: (state, action) => {
            state.statusRespon = "";
        }
    }, extraReducers: (builder) => {
        builder
            // get all
            .addCase(getSPPASlice.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(getSPPASlice.fulfilled, (state, action) => {
                state.loading = false;
                state.SPPALoanList = action?.payload.data || [];
                state.getCount = action.payload.totalData || 0;
            })
            .addCase(getSPPASlice.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            // get detail
            .addCase(getSPPALoanDetailSlice.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(getSPPALoanDetailSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.SPPALoanDetail = action?.payload
            })
            .addCase(getSPPALoanDetailSlice.pending, (state) => {
                state.loading = true;
            })
            // update status
            .addCase(putSPPAStatus.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(putSPPAStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action?.payload
            })
            .addCase(putSPPAStatus.pending, (state) => {
                state.loading = true;
            })
            // cetak SPPA
            .addCase(cetakSPPAMulti.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(cetakSPPAMulti.fulfilled, (state) => {
                state.loading = false;
                notification.success({
                    message: "Berhasil Cetak SPPA",
                    description: "File PDF berhasil dibuka di tab baru.",
                });
            })
            .addCase(cetakSPPAMulti.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                notification.error({
                    message: "Gagal Cetak SPPA",
                    description: action.payload,
                });
            })
            // save terima polis
            .addCase(saveTerimaPolis.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(saveTerimaPolis.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action?.payload
            })
            .addCase(saveTerimaPolis.pending, (state) => {
                state.loading = true;
            });  
    },
});

export const {
    showNotification,
    hideNotification,
    showLoading,
    resetStatusRespon
} = SPPASlice.actions;

export default SPPASlice.reducer;